import ListWidgetMixin from "../../mixins/ListWidgetMixin";

Vue.asyncComponent('ak-collapsible-list', {
    mixins: [ListWidgetMixin],
    props: {
        items: {
            type: Array,
            required: false,
        },
    }
}, 'layout/collapsible/ak-collapsible-list.html');